require('./hireCardOpenCreditView.scss');

// @vendors
const PropTypes = require('prop-types');
const React = require('react');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');

// @helpers
const { formatText, getFinalTitle } = require('core/i18n').i18n;
const { ownerFromAccount } = require('utilities/contactCenter/cardHireHelper')
const { isAvailableHireCreditCards } = require('utilities/cardsHelper');

// @actions
const hireCardOpenCreditActions = require('actions/hireCardOpenCredit');
const hireCreditLimitActions = require('actions/hireCreditLimit');
const preContractualMailActions = require('actions/contactCenter/preContractualMailInfo/preContractualMailInfo');
const mergePreContractualsPDF = require('actions/mergePreContractualsPDF');
const shippingAddressAction = require('actions/shippingAddress');
const blockedAccountsAction = require('actions/blockedAccounts');
const precontractualDocumentMailAction = require('actions/precontractualDocumentsMailer');
const termsAndCondsInfoActions = require('actions/termsAndCondsInfo');
const hireCardCreditINEActions = require('actions/commons/hireCardCreditINE');
const printedActions = require("actions/contactCenter/printer");
const mortgageRequestHolderConfirmation = require("actions/mortgageRequest/mortgageRequestHolderConfirmation");

// @commons
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');

// @components
const HireCardOpenCreditStep1 = require('components/hire/cardOpenCredit/hireCardOpenCreditStep1/hireCardOpenCreditStep1');
const HireCardOpenCreditStep2 = require('components/hire/cardOpenCredit/hireCardOpenCreditStep2/hireCardOpenCreditStep2');
const HireCardOpenCreditStep3 = require('components/hire/cardOpenCredit/hireCardOpenCreditStep3/hireCardOpenCreditStep3');
const HireCardOpenCreditStep4 = require('components/hire/cardOpenCredit/hireCardOpenCreditStep4/hireCardOpenCreditStep4');
const HireCardOpenCreditStep5 = require('components/hire/cardOpenCredit/hireCardOpenCreditStep5/hireCardOpenCreditStep5');
const HireCardOpenCreditStepINE = require('components/hire/cardINEDocument/hireCardOpenCreditStepINE');
const HireCardOpenCreditSuccess = require('components/hire/cardOpenCredit/hireCardOpenCreditSuccess/hireCardOpenCreditSuccess');
const HireCarOpenCreditError = require('components/hire/cardOpenCredit/hireCardOpenCreditError/hireCardOpenCreditError');
const HireCardSidebar = require('components/hire/hireCardSidebar/hireCardSidebar');
const { CallMeBack } = require('components/callMeBack/callMeBack');
const WebappRender = require('components/conditionalRender/webappRender')
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');

// @constants
const {
    CREDIT_CARD_STANDARD,
    CREDIT_CARD_SUBTYPE_VISA,
    CREDIT_CARD_TYPE_VISA,
    REDIRECT_URL,
    THIRD_STEP,
    WIZARD_FIRST_STEP,
    WIZARD_SECOND_STEP
} = require('constants/index');
const { HIRE_CARD_OPEN_CREDIT } = require('constants/operationCodesAccounts');
const { WEB_INACTIVE_ACCOUNT_ENABLED, CREDIT_CARD_REVOLVING_PROCESS, LIMIT_CREDIT_CARD, ES_COUNTRY, MESSAGE_HIRE_24H, NOT_ALLOWED_NEW_CREDIT_CARDS_FLOW_COUNTRIES } = require('constants/flagBasedFeatures');
const { catalogue, analyticsId } = require('../../components/hire/cardOpenCredit/analytics/hireCardOpenCreditAnalytics');

class HireCardOpenCreditView extends React.Component {
    constructor(props) {
        super(props);
        this.isReady = this.isReady.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
    }

    componentDidMount() {
        const {
            getBlockedAccounts,
            getshippingAddressList,
            immAccounts,
            match: { params: { redirect } },
            resetPrecontractualDocumentMail,
            validateStep,
            immFlagBasedFeatures,
            reset,
            resetBlockedAccounts,
            resetPrecontractualMail,
            resetTermsAndCondsText,
        } = this.props;
        const newCardsFF = immFlagBasedFeatures.get(NOT_ALLOWED_NEW_CREDIT_CARDS_FLOW_COUNTRIES);
        if (newCardsFF) {
            reset();
            resetBlockedAccounts();
            resetTermsAndCondsText();
            if (__CONTACT_CENTER__) resetPrecontractualMail()

        }
        resetPrecontractualDocumentMail();
        if (redirect === REDIRECT_URL) {
            validateStep(WIZARD_FIRST_STEP);
        }
        getshippingAddressList();
        getBlockedAccounts(immAccounts.get('byId').toList(), HIRE_CARD_OPEN_CREDIT);
    }

    componentWillUnmount() {
        const {
            reset,
            resetBlockedAccounts,
            resetPrecontractualMail,
            resetTermsAndCondsText,
        } = this.props
        reset();
        resetBlockedAccounts();
        resetTermsAndCondsText();

        if (__CONTACT_CENTER__) resetPrecontractualMail();
    }

    getProcessDetail() {
        return `${CREDIT_CARD_TYPE_VISA}.${CREDIT_CARD_SUBTYPE_VISA}`;
    }

    handleCancel() {
        this.props.history.push('/myprofile/cards');
    }

    isReady() { // it warns the user if he's about to lose changes
        const { immHireCardOpenCredit } = this.props;
        let showPreLeaveModal = true;

        if (immHireCardOpenCredit.get('visibleStep') === 1) {
            showPreLeaveModal = false;
        }

        return showPreLeaveModal;
    }

    buildSuccessful() {
        const {
            immAccounts,
            immHireCardImageSelector,
            immHireCardNameSelector,
            immHireCardOpenCredit,
            immHireCreditLimit,
            immHirePaymentMethod,
            immProfile,
            immShippingAddressList
        } = this.props;
        const selectedAccount = immHireCardOpenCredit.getIn(['steps', THIRD_STEP, 'accountId']);
        const immAccount = immAccounts.getIn(['byId', selectedAccount]);
        const immShippingAddress = immShippingAddressList.get('shippingAddress');

        const processDetail = this.getProcessDetail();

        return (
            <div className="col-xs-12 col-md-offset-1 col-md-10">
                <HireCardOpenCreditSuccess
                    immAccount={immAccount}
                    immHireCardOpenCredit={immHireCardOpenCredit}
                    immHireCardImageSelector={immHireCardImageSelector}
                    immHireCardNameSelector={immHireCardNameSelector}
                    immHireCreditLimit={immHireCreditLimit}
                    immHirePaymentMethod={immHirePaymentMethod}
                    immProfile={immProfile}
                    immShippingAddress={immShippingAddress}
                    processDetail={processDetail}
                />
            </div>
        );
    }

    buildINE() {
        const { getInitCardsDocuments, immHireCardOpenCredit, cardsConfimationScrollDown, checkCheckedDocument, printedAndSignedRadioChanged, enableButtonOffice, checkRadioButton, immPrinter, hireCardOpenCreditprintDocument } = this.props;
        const documentINE = immHireCardOpenCredit.get('documentINE')
        const scrollDown = immHireCardOpenCredit.get('scrollDown')
        const agreeIneCheckbox = immHireCardOpenCredit.get('agreeIneCheckbox')
        const checkButtonRadio = immHireCardOpenCredit.get('checkButtonRadio')
        const printDocument = immHireCardOpenCredit.get('printDocument')
        const documentsPrintedAndSigned = immHireCardOpenCredit.get('cardsDocumentsPrintedAndSigned')

        return (
            <HireCardOpenCreditStepINE
                documentINE={documentINE}
                cardsConfimationScrollDown={cardsConfimationScrollDown}
                scrollDown={scrollDown}
                checkCheckedDocument={checkCheckedDocument}
                agreeIneCheckbox={agreeIneCheckbox}
                printedAndSignedRadioChanged={printedAndSignedRadioChanged}
                enableButtonOffice={enableButtonOffice}
                checkRadioButton={checkRadioButton}
                checkButtonRadio={checkButtonRadio}
                hireCardOpenCreditprintDocument={hireCardOpenCreditprintDocument}
                printDocument={printDocument}
                immPrinter={immPrinter}
                documentsPrintedAndSigned={documentsPrintedAndSigned}
                getInitCardsDocuments={getInitCardsDocuments}
            />
        );
    }

    buildWizardHiringSteps() {
        const {
            handleAccountChange,
            handleAgreementCheckboxChange,
            hireCardOpenCredit,
            immAccounts,
            immFlagBasedFeatures,
            immGlobalVariables,
            immHireCardImageSelector,
            immHireCardNameSelector,
            immHireCardOpenCredit,
            immHireContactData,
            immHireCreditLimit,
            immHireInformation,
            immHirePaymentMethod,
            immProfile,
            immShippingAddressList,
            immPdfData,
            requestPDFDownload,
            requestPDFMerge,
            sendPrecontractualDocumentMail,
            setAllAccountsToInactive,
            setHireCreditLimit,
            setShippingAddress,
            setTermsAndCondsText,
            setVisibleStep,
            setWillCancel,
            toggleCreditLimitModal,
            validate,
            validateStep,
            immRevolvingPersistentData,
            onHandleChangeCheckBoxCC,
            myCardsTarjetasHire,
            hireCardOpenCreditprintDocument,
            cardsConfimationScrollDownPolicy,
            hireCardOpenCreditprintDocumentPolicy,
            printedAndSignedRadioChanged,
            enableButtonOffice,
            checkRadioButtonPolicy,
            getInitCardsDocuments,
            processEmail
        } = this.props;

        const newCardsFF = immFlagBasedFeatures.get(NOT_ALLOWED_NEW_CREDIT_CARDS_FLOW_COUNTRIES);
        const wizardActions = {
            cancel: this.handleCancel,
            finish: newCardsFF ? myCardsTarjetasHire : hireCardOpenCredit,
            setVisibleStep,
            setWillCancel,
            validateStep
        };
        const showPreLeaveModal = this.isReady();
        const documentsPrintedAndSigned = immHireCardOpenCredit.get('cardsDocumentsPrintedAndSigned')


        let immSteps = newCardsFF && (!__CONTACT_CENTER__ || isPrintOfficeMode()) ? immHireCardOpenCredit.get('newSteps') : immHireCardOpenCredit.get('steps');
        const visibleStep = immHireCardOpenCredit.get('visibleStep')
        immSteps = immSteps.map((step, index) => {
            if (index < visibleStep) {
                return step.set('valid', true);
            }
            return step;
        });
        const sendMailParams = {
            type: CREDIT_CARD_TYPE_VISA,
            subType: CREDIT_CARD_SUBTYPE_VISA,
            standar: CREDIT_CARD_STANDARD
        };
        const immShippingAddress = immShippingAddressList.get('shippingAddress');
        const hasShippingAddress = true;
        const nextButtonDisabledStep2 = immHireCardImageSelector.get('isFetching') || immHireCardNameSelector.get('isFetching');
        const gestorCrossEnabled = immFlagBasedFeatures.get('web-gc-enabled');
        const showIneAndRevolving = immFlagBasedFeatures.get(CREDIT_CARD_REVOLVING_PROCESS);
        const agreeIneCheckbox = immHireCardOpenCredit.get('agreeIneCheckbox')
        const checkButtonRadio = immHireCardOpenCredit.get('checkButtonRadio')
        const productName = this.getProcessDetail();
        const tealiumData = [
            catalogue[analyticsId.OPEN_CREDIT_CARD_STEP_1_VIEW]({ productName }),
            catalogue[analyticsId.OPEN_CREDIT_CARD_STEP_2_VIEW]({ productName }),
            catalogue[analyticsId.OPEN_CREDIT_CARD_STEP_3_VIEW]({ productName }),
            catalogue[analyticsId.OPEN_CREDIT_CARD_STEP_4_VIEW]({ productName }),
            catalogue[analyticsId.OPEN_CREDIT_CARD_STEP_5_VIEW]({ productName }),
        ];

        const isShippingAddressButtonDisabled = !!immShippingAddressList && !immShippingAddressList.get('shippingAddressType') && immFlagBasedFeatures.get(ES_COUNTRY);
        const loadingFlag = immHireCardOpenCredit.get('loadingFlag');
        const checkboxChecked = immHireCardOpenCredit.get('agreeIneCheckbox')
        const newFinalButtonDisabledCC = newCardsFF && checkboxChecked
        const commonSteps = [
            <WizardStep
                isLoading={loadingFlag}
                cancelButton={true}
                position="first"
            >
                <WebappRender>
                    <HireCardOpenCreditStep1
                        flagBasedFeatures={immFlagBasedFeatures}
                        gestorCrossEnabled={gestorCrossEnabled}
                        hireCmsKey={__CONTACT_CENTER__ ? "visaopen_cc" : "visaopen"}
                        immHireInformation={immHireInformation}
                        requestPDFMerge={requestPDFMerge}
                        showIneAndRevolving={showIneAndRevolving}
                    />
                </WebappRender>
                <ContactCenterRender>
                    <HireCardOpenCreditStep1
                        flagBasedFeatures={immFlagBasedFeatures}
                        gestorCrossEnabled={gestorCrossEnabled}
                        contractName="visa-open"
                        handleAgreementCheckboxChange={handleAgreementCheckboxChange}
                        hireCmsKey={__CONTACT_CENTER__ ? "visaopen_cc" : "visaopen"}
                        immHireCardOpenCredit={immHireCardOpenCredit}
                        immHireInformation={immHireInformation}
                        immProfileFields={immProfile}
                        requestPDFMerge={requestPDFMerge}
                        sendMailParams={sendMailParams}
                        setTermsAndCondsText={setTermsAndCondsText}
                        showIneAndRevolving={showIneAndRevolving}
                    />
                </ContactCenterRender>
            </WizardStep>,
            <WizardStep
                cancelButton={true}
                nextButtonDisabled={nextButtonDisabledStep2}
                onBackClick={false}
                position="middle"
            >
                <HireCardOpenCreditStep2
                    immFlagBasedFeatures={immFlagBasedFeatures}
                    immHireCardImageSelector={immHireCardImageSelector}
                    immHireCardNameSelector={immHireCardNameSelector}
                />
            </WizardStep>,
            <WizardStep
                cancelButton={true}
                nextButtonDisabled={immHireCreditLimit.get('isFetching') || immRevolvingPersistentData.get('isIframeError')}
                onBackClick={false}
                position="middle"
            >
                <HireCardOpenCreditStep3
                    handleAccountChange={handleAccountChange}
                    immAccounts={immAccounts}
                    immFlagBasedFeatures={immFlagBasedFeatures}
                    immGlobalVariables={immGlobalVariables}
                    immHireCardImageSelector={immHireCardImageSelector}
                    immHireCardOpenCredit={immHireCardOpenCredit}
                    immHireCreditLimit={immHireCreditLimit}
                    immHirePaymentMethod={immHirePaymentMethod}
                    isInactiveAccountsEnabled={immFlagBasedFeatures.get(WEB_INACTIVE_ACCOUNT_ENABLED)}
                    setAllAccountsToInactive={setAllAccountsToInactive}
                    setHireCreditLimit={setHireCreditLimit}
                    toggleCreditLimitModal={toggleCreditLimitModal}
                    validate={validate}
                />
            </WizardStep>,
            <WizardStep
                cancelButton={true}
                onBackClick={false}
                position="middle"
                nextButtonDisabled={isShippingAddressButtonDisabled}
            >
                <HireCardOpenCreditStep4
                    immShippingAddressList={immShippingAddressList}
                    setShippingAddress={setShippingAddress}
                    immHireContactData={immHireContactData}
                    getInitCardsDocuments={getInitCardsDocuments}
                    newCardsFF={newCardsFF}
                />
            </WizardStep>,
            <WizardStep
                addLoadingBehaviour
                cancelButton={true}
                immFinalButton={'hireCardOpenCredit-hire'}
                isLoading={immHireCardOpenCredit.get('isFetching')}
                onBackClick={false}
                position="last"
                officeSignature={newCardsFF && isPrintOfficeMode()}
                finalButtonDisabled={newCardsFF ? (newFinalButtonDisabledCC ? false : true) : null}
            >
                <HireCardOpenCreditStep5
                    contractName="visa-open"
                    handleAgreementCheckboxChange={handleAgreementCheckboxChange}
                    immHireCardImageSelector={immHireCardImageSelector}
                    immHireCardNameSelector={immHireCardNameSelector}
                    immHireCardOpenCredit={immHireCardOpenCredit}
                    immHireCreditLimit={immHireCreditLimit}
                    immHirePaymentMethod={immHirePaymentMethod}
                    immPdfData={immPdfData}
                    immProfile={immShippingAddressList.get('shippingAddress')}
                    immShippingAddressList={immShippingAddressList}
                    operativeName={__CONTACT_CENTER__ ? "operatives-cardHire_visaOpenNew" : undefined}
                    requestPDFDownload={requestPDFDownload}
                    sendMailParams={sendMailParams}
                    sendPrecontractualDocumentMail={sendPrecontractualDocumentMail}
                    setTermsAndCondsText={setTermsAndCondsText}
                    showIneAndRevolving={showIneAndRevolving}
                    immFlagBasedFeatures={immFlagBasedFeatures}
                    onHandleChangeCheckBoxCC={onHandleChangeCheckBoxCC}
                    hireCardOpenCreditprintDocument={hireCardOpenCreditprintDocument}
                    cardsConfimationScrollDownPolicy={cardsConfimationScrollDownPolicy}
                    hireCardOpenCreditprintDocumentPolicy={hireCardOpenCreditprintDocumentPolicy}
                    printedAndSignedRadioChanged={printedAndSignedRadioChanged}
                    enableButtonOffice={enableButtonOffice}
                    checkRadioButtonPolicy={checkRadioButtonPolicy}
                    documentsPrintedAndSigned={documentsPrintedAndSigned}
                    processEmail={processEmail}


                />
            </WizardStep>
        ];
        const newSteps = newCardsFF && (__CONTACT_CENTER__ && isPrintOfficeMode() || !__CONTACT_CENTER__) ? [
            ...commonSteps.slice(0, 4),
            <WizardStep
                cancelButton={true}
                onBackClick={false}
                position="middle"
                nextButtonDisabled={isPrintOfficeMode() ? !checkButtonRadio : !agreeIneCheckbox}
            >
                {this.buildINE()}
            </WizardStep>,
            ...commonSteps.slice(4)
        ] : commonSteps;
        return (
            <div>
                <div className="col-xs-12 col-md-8">

                    <Wizard
                        actions={wizardActions}
                        immSteps={immSteps}
                        showPreLeaveModal={showPreLeaveModal}
                        stepsAmount={immSteps.size}
                        tealium={tealiumData[visibleStep - 1]}
                        visibleStep={visibleStep}
                        wizardClass="hire-card-open-credit__wizard"
                        isTaggingSecondVersion
                    >
                        {newSteps}
                    </Wizard>

                </div>
                <div className="col-xs-12 col-md-4">
                    <div className="row">
                        <div className="col-xs-6 col-md-12 grid-view--variable-cell-separation">
                            <HireCardSidebar
                                immAccounts={immAccounts}
                                immGlobalVariables={immGlobalVariables}
                                immHireCardImageSelector={immHireCardImageSelector}
                                immHireCardNameSelector={immHireCardNameSelector}
                                immHireCreditLimit={immHireCreditLimit}
                                immHirePaymentMethod={immHirePaymentMethod}
                                immShippingAddressList={immShippingAddressList}
                                immAddress={immShippingAddress}
                                immProfile={immProfile}
                                selectedAccount={immSteps.getIn([THIRD_STEP, 'accountId'])}
                                hasShippingAddress={hasShippingAddress}
                            />
                        </div>
                        <div className="col-xs-6 col-md-12 grid-view--fix-cell-separation">
                            <CallMeBack context="contracts" modifier="contracts-view" pageTitle={formatText('breadcrumb-cards')} hasEntrance={false} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const {
            immHireCardOpenCredit,
            immAccounts,
            immCards,
            immFlagBasedFeatures,
            immProfile,
        } = this.props;
        const pageTitle = getFinalTitle('hireCardOpenCredit-pageTitle');
        let hasAvailableAccounts = true;
        if (__CONTACT_CENTER__) {
            hasAvailableAccounts = ownerFromAccount(immAccounts);
        }

        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-cards'),
                url: '/myprofile/cards'
            },
            {
                text: formatText("hireCardOpenCredit-breadcrumb")
            }
        ];

        const hasAvailableCreditCards = isAvailableHireCreditCards(immCards);
        const isSecondStep = immHireCardOpenCredit.get('visibleStep') == WIZARD_SECOND_STEP;
        const isNerudaUser = immProfile.get('isNerudaUser');
        const creditCardsLimitExceed = immFlagBasedFeatures.get(LIMIT_CREDIT_CARD) && !isNerudaUser && !hasAvailableCreditCards && isSecondStep;
        const processDetail = this.getProcessDetail();
        const hireRestrictionFlag = immHireCardOpenCredit.getIn(['steps', WIZARD_FIRST_STEP - 1, 'hireRestriction']);
        const hireRestrictionFF = immFlagBasedFeatures.get(MESSAGE_HIRE_24H);

        let content;
        if (immHireCardOpenCredit.get('error')
            || (__CONTACT_CENTER__ && !hasAvailableAccounts)
            || creditCardsLimitExceed) {
            content = (
                <div className="col-xs-12 col-md-offset-1 col-md-10">
                    <HireCarOpenCreditError
                        immHireCardOpenCredit={immHireCardOpenCredit}
                        hasAvailableAccounts={__CONTACT_CENTER__ ? hasAvailableAccounts : undefined}
                        processDetail={processDetail}
                        maxAllowedNumberCards={creditCardsLimitExceed}
                    />
                </div>
            );
        } else if (hireRestrictionFlag && hireRestrictionFF) {
            content = (
                <div className="col-xs-12 col-md-offset-1 col-md-10">
                    <HireCarOpenCreditError
                        immHireCardOpenCredit={immHireCardOpenCredit}
                        hasAvailableAccounts={__CONTACT_CENTER__ ? hasAvailableAccounts : undefined}
                        processDetail={processDetail}
                        maxAllowedNumberCards={creditCardsLimitExceed}
                        hireRestrictionFlag={hireRestrictionFlag}
                    />
                </div>
            );
        } else if (immHireCardOpenCredit.get('submitSuccessful')) {
            content = this.buildSuccessful();
        } else {
            content = this.buildWizardHiringSteps();
        }

        return (
            <div className="hire-card-open-credit">
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="medium" section="pg" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={mappingBreadcrumb}
                                finalTitle={pageTitle}
                            />
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            {content}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

HireCardOpenCreditView.propTypes = {
    handleAccountChange: PropTypes.func.isRequired,
    handleAgreementCheckboxChange: PropTypes.func.isRequired,
    hireCardOpenCredit: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immCards: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immGlobalVariables: PropTypes.object.isRequired,
    immHireCardImageSelector: PropTypes.object.isRequired,
    immHireCardNameSelector: PropTypes.object.isRequired,
    immHireCardOpenCredit: PropTypes.object.isRequired,
    immHireContactData: PropTypes.object.isRequired,
    immHireCreditLimit: PropTypes.object.isRequired,
    immHireInformation: PropTypes.object.isRequired,
    immHirePaymentMethod: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    immPdfData: PropTypes.object.isRequired,
    match: PropTypes.object,
    reset: PropTypes.func.isRequired,
    resetPrecontractualMail: PropTypes.func.isRequired,
    resetTermsAndCondsText: PropTypes.func.isRequired,
    requestPDFMerge: PropTypes.func.isRequired,
    requestPDFDownload: PropTypes.func.isRequired,
    resetBlockedAccounts: PropTypes.func,
    resetPrecontractualDocumentMail: PropTypes.func,
    setAllAccountsToInactive: PropTypes.func.isRequired,
    setHireCreditLimit: PropTypes.func.isRequired,
    setTermsAndCondsText: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    sendPrecontractualDocumentMail: PropTypes.func.isRequired,
    toggleCreditLimitModal: PropTypes.func.isRequired,
    validate: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    getshippingAddressList: PropTypes.func,
    getBlockedAccounts: PropTypes.func,
    immShippingAddressList: PropTypes.object,
    setShippingAddress: PropTypes.func,
    immRevolvingPersistentData: PropTypes.object,
};

module.exports.constructor = HireCardOpenCreditView;
module.exports.HireCardOpenCreditView = connect(
    state => ({
        immAccounts: state.accounts,
        immCards: state.cards,
        immFlagBasedFeatures: state.flagBasedFeatures,
        immGlobalVariables: state.globalVariables,
        immHireCardImageSelector: state.hireCardImageSelector,
        immHireCardNameSelector: state.hireCardNameSelector,
        immHireCardOpenCredit: state.hireCardOpenCredit,
        immHireContactData: state.hireContactData,
        immHireCreditLimit: state.hireCreditLimit,
        immHireInformation: state.hireInformation,
        immHirePaymentMethod: state.hirePaymentMethod,
        immPdfData: state.precontractualsMergePdfs,
        immProfile: state.profile,
        immShippingAddressList: state.shippingAddress,
        immRevolvingPersistentData: state.revolvingPersistentData,
        immPrinter: state.printer,

    }),
    {
        getBlockedAccounts: blockedAccountsAction.getBlockedAccounts,
        getshippingAddressList: shippingAddressAction.getShippingAddressList,
        handleAccountChange: hireCardOpenCreditActions.setAccount,
        handleAgreementCheckboxChange: hireCardOpenCreditActions.setAgreementCheckbox,
        onHandleChangeCheckBoxCC: hireCardOpenCreditActions.onHandleChangeCheckBoxCC,
        hireCardOpenCredit: hireCardOpenCreditActions.hireCardOpenCredit,
        requestPDFDownload: mergePreContractualsPDF.downloadMergedPDF,
        requestPDFMerge: mergePreContractualsPDF.requestPDFMerge,
        reset: hireCardOpenCreditActions.reset,
        resetBlockedAccounts: blockedAccountsAction.resetBlockedAccounts,
        resetPrecontractualDocumentMail: precontractualDocumentMailAction.resetPrecontractualDocumentMail,
        resetPrecontractualMail: preContractualMailActions.resetPrecontractualMail,
        resetTermsAndCondsText: termsAndCondsInfoActions.reset,
        sendPrecontractualDocumentMail: precontractualDocumentMailAction.sendPrecontractualDocumentMail,
        setAllAccountsToInactive: hireCardOpenCreditActions.setAllAccountsToInactive,
        setHireCreditLimit: hireCreditLimitActions.setHireCreditLimit,
        setShippingAddress: shippingAddressAction.setShippingAddress,
        setTermsAndCondsText: termsAndCondsInfoActions.setTermsAndCondsText,
        setVisibleStep: hireCardOpenCreditActions.setVisibleStep,
        setWillCancel: hireCardOpenCreditActions.setWillCancel,
        toggleCreditLimitModal: hireCreditLimitActions.toggleModal,
        validate: hireCardOpenCreditActions.validate,
        validateStep: hireCardOpenCreditActions.validateStep,
        cardsConfimationScrollDown: hireCardCreditINEActions.cardsConfimationScrollDown,
        getInitCardsDocuments: hireCardCreditINEActions.getInitCardsDocuments,
        cardsConfimationScrollDownPolicy: hireCardCreditINEActions.cardsConfimationScrollDownPolicy,
        checkCheckedDocument: hireCardCreditINEActions.checkCheckedDocument,
        printedAndSignedRadioChanged: printedActions.printedAndSignedRadioChanged,
        enableButtonOffice: mortgageRequestHolderConfirmation.enableButtonOffice,
        checkRadioButton: hireCardOpenCreditActions.checkRadioButton,
        checkRadioButtonPolicy: hireCardOpenCreditActions.checkRadioButtonPolicy,
        hireCardOpenCreditprintDocument: hireCardOpenCreditActions.printDocument,
        hireCardOpenCreditprintDocumentPolicy: hireCardOpenCreditActions.printDocumentPolicy,
        myCardsTarjetasHire: hireCardOpenCreditActions.myCardsTarjetasHire,
        processEmail: hireCardOpenCreditActions.processEmail,



    }
)(withRouter(HireCardOpenCreditView));
